import React from 'react';
import { MiniProg } from '../ui/primitives';

/**
 * Course-wide completion for one learner, shared by the Enrollees and GradeBook tabs.
 *
 * Shows "1/3" rather than "33%" on purpose: a bare "0%" next to an empty bar reads as a
 * broken widget, whereas "0/3" says there are three gradable items and none are done. The
 * percentage stays available on hover for anyone who wants it.
 */
export default function CourseProgressCell({ row }) {
  const percent = Number(row.progress) || 0;
  const completed = Number(row.completedItems) || 0;
  const total = Number(row.totalItems) || 0;

  // completedItems/totalItems arrive with the current API. A cached response from before
  // they existed still has `progress`, so fall back to the percentage instead of
  // mislabelling that learner as having nothing to complete.
  let label = `${percent}%`;
  if (total > 0) {
    label = `${completed}/${total}`;
  } else if (percent === 0) {
    label = '—';
  }

  return (
    <MiniProg title={`${percent}% complete`}>
      <div className="track"><i style={{ width: `${percent}%` }} /></div>
      <span className="tnum">{label}</span>
    </MiniProg>
  );
}
